module.exports = __webpack_public_path__ + "static/media/icon_classes_on.572bf0ff.svg";